import { Wrapper } from './style';

export const UnknownError = () => {
  return (
    <Wrapper>
      <h1>Service temporarily unavailable</h1>
    </Wrapper>
  );
};
